// Notifications
export const INFO_NOTIFICATION_COLOR = 'orange';
export const SUCCESS_NOTIFICATION_COLOR = 'teal';
export const ERROR_NOTIFICATION_COLOR = 'red';
export const WARNING_NOTIFICATION_COLOR = 'orange';

export const AUTH_SESSION_ERROR_CODE = 4010101;
export const INVALID_EMAIL_OR_PASSWORD_ERROR_CODE = 4010102;
export const INVALID_PASSWORD_ERROR_CODE = 4010103;
export const INVALID_TWO_FACTOR_CHALLENGE_ERROR_CODE = 4010104;
export const INVALID_TWO_FACTOR_CODE_ERROR_CODE = 4010105;
export const INACTIVE_USER_ERROR_CODE = 4030101;
export const PASSWORD_CHANGE_REQUIRED_ERROR_CODE = 4030104;
export const DUPLICATE_USER_ERROR_CODE = 4000104;
export const TWO_FACTOR_ALREADY_ENABLED_ERROR_CODE = 4000105;
export const TWO_FACTOR_NOT_ENABLED_ERROR_CODE = 4000106;
export const TWO_FACTOR_SETUP_NOT_STARTED_ERROR_CODE = 4000107;
export const PASSWORD_REUSE_ERROR_CODE = 4000108;
export const CANNOT_SET_ENTITY_STATUS = 4030102;
export const INSUFFICIENT_RIGHTS_ERROR_CODE = 4030103;
export const INVALID_XML_FILE_CONTENTS_ERROR_CODE = 4000001;
export const REVISION_NOT_SIGNED_YET_ERROR_CODE = 4004101;
export const REVISION_SIGNATURE_INVALID_ERROR_CODE = 4004102;
export const NO_ENTITY_EXISTS_ERROR_CODE = 4003101;
export const REVISION_NOT_IN_PROGRESS_ERROR_CODE = 4004103;
